/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { Typography } from "@material-ui/core";
import { LightAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";

/**
 * Displays developer docs for public web chat functions
 */
export const CallMeNowScriptDocs = () => {
	return (
		<div style={{ padding: "30px 20px" }}>
			<Typography>
				PACE Call Me Now exposes a set of public function for developers, to set custom attributes for widget. These
				attributes will be placed on the final Amazon Connect Contact Trace Record (CTR).
			</Typography>

			<div style={{ marginTop: 20 }}>
				<SyntaxHighlighter language="javascript" style={docco}>
					{`
/**
 * Set any attribute value. Existing attribute with the same name will be replaced.
 * Attribute value must be a primitive (string, number, boolean...), arrays and
 * objects are not allowed. Attribute name cannot contain spaces in order to be saved
 * on the CTR. Value will be converted to a string before saving (CTR attributes must be a string).
 * @param {string} attributeName
 * @param {string} attributeValue
 */
window.paceCallMeNow.setAttribute(attributeName, attributeValue);
/**
 * Remove specific attribute by name
 * @param {string} attributeName
 */
window.paceCallMeNow.removeAttribute(attributeName);

/**
 * Remove all attributes
 */
window.paceCallMeNow.removeAllAttributes();

/**
 * Returns the attribute value if it exists
 * @param {string} attributeName
 * @returns attribute value or undefined
 */
window.paceCallMeNow.getAttribute(attributeName);

/**
 * Returns object containing all attributes
 * @returns attributes object
 */
window.paceCallMeNow.getAllAttributes();

`}
				</SyntaxHighlighter>
			</div>
		</div>
	);
};
